import apiClient from './axiosClient';

const searchZipcodes = async (input: string) => {
  return apiClient.get(`zipcodes/autocomplete/${input}`).then((res) => res.data);
};

export default searchZipcodes;
